import { getExportTableApi } from "./getExportTableApi";

export const getExportTableSetData = async (
  lang,
  setMessageResponse,
  cookies,
  action,
  setTableData,
  setTableLoader,
  customer_id
) => {
  const response = await getExportTableApi(action, lang, cookies, customer_id);
  if (response.success) {
    setTableData(() => response.res.data.data);
    setTableLoader(() => false);
  } else {
    const error = response.res;
    if (error.response) {
      setMessageResponse((prev) => ({
        ...prev,
        success: false,
        message: error.response.data.message,
        isShow: true,
      }));
    } else {
      setMessageResponse((prev) => ({
        ...prev,
        success: false,
        message: "Timeout",
        isShow: true,
      }));
    }
  }
};
